/**
 * @generated SignedSource<<502bddf04aec5671a5256bfab1926298>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineStoreCustomizeSections_dialogRoles$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoleListItem_role">;
  readonly " $fragmentType": "RoutineStoreCustomizeSections_dialogRoles";
}>;
export type RoutineStoreCustomizeSections_dialogRoles$key = ReadonlyArray<{
  readonly " $data"?: RoutineStoreCustomizeSections_dialogRoles$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineStoreCustomizeSections_dialogRoles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoutineStoreCustomizeSections_dialogRoles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleListItem_role"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "3d9e421a80f648a0fd75748b257f6709";

export default node;
